<template>
  <div>
    我的问卷
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>

</style>